/**
 *
 *
 */
let _initialValue: string | undefined;

export function getOrSetInitialTopQuickFacet(computedValue: string): string {
  if (_initialValue === undefined) {
    _initialValue = computedValue;
  }
  return _initialValue;
}

/*                                        */
export function resetInitialTopQuickFacet(): void {
  _initialValue = undefined;
}

/**
 *
 */
let _initialNbaVisibleValues: string | undefined;

export function getOrSetInitialNbaVisibleValues(computedValue: string): string {
  if (_initialNbaVisibleValues === undefined) {
    _initialNbaVisibleValues = computedValue;
  }
  return _initialNbaVisibleValues;
}

/**
 *
 *
 *
 *
 */
let _initialNbaChipIds: Set<string> | undefined;

export function setInitialNbaChipIds(ids: string[]): void {
  if (_initialNbaChipIds === undefined) {
    _initialNbaChipIds = new Set(ids);
  }
}

export function getInitialNbaChipIds(): Set<string> {
  return _initialNbaChipIds ?? new Set();
}
